// extracted by mini-css-extract-plugin
export default {"title":"title--VZaXJ","scrollable-block":"scrollable-block--_JnC5","scrollableBlock":"scrollable-block--_JnC5","content":"content--Yp0bz","blink":"blink--kdt_Q"};